import { createFileRoute } from '@tanstack/react-router'
import { TravelSettingsFeature } from '@/features/organizations/settings/travel'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/travel'
)({
  component: TravelSettingsFeature,
})
